import { render, staticRenderFns } from "./ComplieHeaderGroupViewMenu.vue?vue&type=template&id=12246c29&scoped=true"
import script from "./ComplieHeaderGroupViewMenu.vue?vue&type=script&lang=js"
export * from "./ComplieHeaderGroupViewMenu.vue?vue&type=script&lang=js"
import style0 from "./ComplieHeaderGroupViewMenu.vue?vue&type=style&index=0&id=12246c29&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12246c29",
  null
  
)

export default component.exports